import globals from '#utilities/js/ea/globals.js'
import { refresh } from '#components/generics/js/selectors/refresh.js'
import Xready from './meet_x_ready.js'
import Xstop from './meet_x_stop.js'
import { propsReset, meetProps, states, setState } from './props.js'
import { ctrlButton, divmeetClose } from './ui.js'

export const hasReachedStop = () => {
  const props = meetProps()
  const {st} = props
  return st === states.stopping || st === states.ended
}

export default (params) => {
  const props = meetProps()
  if (!hasReachedStop()) {
    if (props.ws) {
      const { readyState } = props.ws
      if (readyState !== WebSocket.CLOSING && readyState !== WebSocket.CLOSED) {
        setState(states.stopping)
        props.ws.close()
        props.ws = null
      }
    }

    try {
      Xready() && Xstop()
    } catch (e) {
      console.error(e)
    }
  }
  params = params ?? {}
  refresh(null, null)
  globals.ea_link_msg_set(null)
  //_props.set(meetFragment(), propsReset())
  propsReset()
  const { stayInMeetPage = false } = params
  if (!stayInMeetPage) {
    divmeetClose()
  }
  setState(states.ended)
}

